import { render, staticRenderFns } from "./AggregationTable.vue?vue&type=template&id=3fd70460&"
import script from "./AggregationTable.vue?vue&type=script&lang=js&"
export * from "./AggregationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fd70460')) {
      api.createRecord('3fd70460', component.options)
    } else {
      api.reload('3fd70460', component.options)
    }
    module.hot.accept("./AggregationTable.vue?vue&type=template&id=3fd70460&", function () {
      api.rerender('3fd70460', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/FormBuilder/AggregationTable.vue"
export default component.exports